import React from 'react';
import Button from '../../../components/controls/Button';
import FormGroup from '../../../components/controls/Form/components/FormGroup';
import InputField from '../../../components/controls/Form/components/InputField';
import Heading from '../../../components/controls/Typography/Heading';
import useRecommendation from '../../../utils/useRecommendation';

import './AddMember.less';

/**
 * @typedef {import('../../../store/reducers/userReducer').TDataAccount} TDataAccount
 * @param {{primaryMember:TDataAccount|null}} props
 * @returns
 */
const AddMember = (props) => {
  const { primaryMember } = props;
  const recommendation = useRecommendation();

  const isValid = () => {
    return recommendation.actions.committeeMembers.allowAddMore;
  };

  const handleAddCommitteeMember = () => {
    recommendation.actions.committeeMembers.addNew();
  };

  /**
   *
   * @param {string} name
   * @param {string} value
   * @param {number} idx
   */
  const handleChange = (name, value, idx) => {
    recommendation.actions.committeeMembers.updateAt(value, idx);
  };

  /**
   *
   * @param {number} idx
   * @returns
   */
  const handleRemoveCommitteeMember = idx => () => {
    recommendation.actions.committeeMembers.removeAt(idx);
  };

  return (
    <div className="container lsn-question-group lsn-question-group-committee" data-block-name={'Committee Members'}>
      <div className="lsn-question-group-header">
        <Heading bold level={3} tabIndex={0} asSpan>Committee Members</Heading>
      </div>
      <div className='lsn-committee-members-grid container'>
        <div className="lsn-committeeMember lsn-committeeMember-header">
          <FormGroup
            label={`Primary:`}
            horizontal
            controlRender={(params) => <InputField
              autofocus={true}
              disabled
              title={'Member Name '}
              inputType={'text'}
              name={'memberName'}
              value={primaryMember?.profile.firstName + ' ' + primaryMember?.profile.lastName}
              {...params}
            />}
          />
        </div>
        {(recommendation.item?.committeeMembers ?? []).map((committeeMember, idx) => (
          <div className="lsn-committeeMember lsn-committeeMember-addMember" key={idx + ':' + committeeMember.memberName}>

            <FormGroup
              label={`Member ${idx + 2}:`}
              required
              horizontal
              controlRender={(params) => <InputField
                autofocus={true}
                title={'Member Name '}
                inputType={'text'}
                name={'memberName'}
                onChange={(n, value) => handleChange(n, value, idx)}
                value={committeeMember.memberName}
                limit={150}
                customErrorPrefix={'Member Name'}
                {...params}
              />}
            />

            <Button
              link
              danger
              className='lsn-committeeMember-removeMemberButton'
              onClick={handleRemoveCommitteeMember(idx)}
            >
              Remove
            </Button>

          </div>
        ))}
      </div>
      <div className="buttons-wrapper">
        {isValid() ? (<>
          <Button
            onClick={handleAddCommitteeMember}
            className={'lsn-committeeMember-addMemberButton'}
            primary
            outline
            type='button'
          >
            + Add Member
          </Button>
          <span className="lsn-committeeMember-memberLabel">
            You may list up to {recommendation.actions.committeeMembers.capacity} more committee members
          </span>
        </>
        ) : (
          <div className="lsn-committeeMember-memberLabel max-items-added-warning-label">
            <i className="far fa-exclamation-triangle" />
            You have reached the maximum amount of members to add.
          </div>
        )}
      </div>
      <div className='divider'></div>
    </div>
  );
}

export default AddMember;
